// extracted by mini-css-extract-plugin
export default {"body":"PosTech_body__ap5n7"};